import { render } from "./TeamTypeCell.vue?vue&type=template&id=fcbb9940"
import script from "./TeamTypeCell.vue?vue&type=script&lang=js"
export * from "./TeamTypeCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__